import React, { useState, useEffect } from 'react';
import '../components/CSS files/Services.css';
import '../App.css';
import arrowback from '../assets/arrow-back.png';
import arrownext from '../assets/arrow-next.png';
import prefabimg from '../assets/PrefabImg.jpg';
import mesh from '../assets/mesh.jpg';
import deliverypic from '../assets/Delivery2.jpg';
import estimatingpic from '../assets/Estimating.jpg';
import barprocessing from '../assets/BarProcessing.jpg';

function Services() {
  const [activeCard, setActiveCard] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [prevSlide, setPrevSlide] = useState(null);
  const [slideDirection, setSlideDirection] = useState('right');

  const handleCardClick = (index) => {
    setActiveCard(index === activeCard ? null : index);
  };

  const projectData = [
    {
      title: 'Bar Processing',
      desc: 'Precision cutting, bending, bundling, and tagging.',
      img: barprocessing,
      details: 'More info coming soon...',
    },
    {
      title: 'Mesh Supply',
      desc: 'Custom shapes and sizes to meet complex project requirements.',
      img: mesh,
      details: 'More info coming soon...',
    },
    {
      title: 'Prefabrication',
      desc: 'Columns, footings, piers, and cages, factory-assembled for easy installation.',
      img: prefabimg,
      details: 'More info coming soon...',
    },
    /*{
      title: '3D BIM Modelling',
      desc: 'Visualise reinforcement before construction begins.',
      img: placeholder,
      details: 'More info coming soon...',
    },*/
    {
      title: 'Estimating & Scheduling',
      desc: 'Accurate quotes and planning support.',
      img: estimatingpic,
      details: 'More info coming soon...',
    },
    {
      title: 'Delivery & Logistics',
      desc: 'A modern fleet with Hiab trucks, computer tracking, and fall-safe unloading for on-time and safe site supply.',
      img: deliverypic,
      details: 'More info coming soon...',
    }
  ];

  // Auto-advance slideshow
  useEffect(() => {
    const interval = setInterval(() => {
    setSlideDirection('right');
    setPrevSlide(currentSlide)
      setCurrentSlide((prev) => (prev + 1) % projectData.length);
    }, 3500); // change seconds depending
    return () => clearInterval(interval);
  }, [currentSlide, projectData.length]);

  const handlePrev = () => {
    setSlideDirection('left');
    setPrevSlide(currentSlide);
    setCurrentSlide((prev) => (prev - 1 + projectData.length) % projectData.length);
  };

  const handleNext = () => {
    setSlideDirection('right');
    setPrevSlide(currentSlide);
    setCurrentSlide((prev) => (prev + 1) % projectData.length);
  };

  return (
    <div className="section-projects">
        <div className="services-header">
            <div className="services-slideshow-img-wrapper">
                {prevSlide !== null && (
                <img
                    key={`prev-${prevSlide}`}
                    src={projectData[prevSlide].img}
                    alt={projectData[prevSlide].title}
                    className={`services-slideshow-bg fade-out slide-${slideDirection}`}
                />
                )}
                <img
                key={`current-${currentSlide}`}
                src={projectData[currentSlide].img}
                alt={projectData[currentSlide].title}
                className={`slideshow-bg fade-in slide-${slideDirection}`}
                onAnimationEnd={() => setPrevSlide(null)}
                />
            </div>
            <div className="services-slideshow-overlay">
                <h1 className="services-slideshow-title">Our Services</h1>
                <div className="services-info-card">
                <h3>{projectData[currentSlide].title}</h3>
                <p>{projectData[currentSlide].desc}</p>
                </div>
                <button className="services-slideshow-button left" onClick={handlePrev}>
                <img src={arrowback} alt="Back"/>
                </button>
                <button className="services-slideshow-button right" onClick={handleNext}>
                <img src={arrownext} alt="Next"/>
                </button>
            </div>
        </div>
      <div className="grid">
        {projectData.map((project, i) => (
          <div
            key={i}
            className={`card vertical-card ${activeCard === i ? 'expanded' : ''}`}
            onClick={() => handleCardClick(i)}
          >
            <img src={project.img} alt={project.title} />
            <div className="card-text">
              <h3>{project.title}</h3>
              <p>{project.desc}</p>
              {activeCard === i && (
                <div className="card-details">
                  <p>{project.details}</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Services;
